import type { JSX } from "react";
import { H1Large } from "../atoms/Heading";
import styled from "styled-components";
import { Desert } from "../atoms/Environments";
import { QuoteForm, FormType } from "../molecules/QuoteForm";
import { P1 } from "../atoms/Paragraph";
import { Spacer } from "../templates/Spacer";
import { StandardSection } from "../templates/StandardSection";
import { color } from "@utils";
import { ExternalRoutes } from "@routes";

interface Props {
  title: string;
  backgroundColor: string;
  clouds: JSX.Element;
}

export const ContactHero = ({ title, backgroundColor, clouds }: Props) => (
  <StandardSection background={backgroundColor}>
    {clouds || null}
    <Desert />
    <Content>
      <StyledH1Large>{title}</StyledH1Large>
      <Spacer height="1.5rem" />
      <Text>
        <P1>
          Fill out the form below and one of our experts will call you back shortly. We aim to reach
          out within 10 minutes during regular working hours.
        </P1>
        <P1>
          <StyledAnchor href={ExternalRoutes.faqChat} target="_blank" rel="noopener noreferrer">
            Already a YuLifer?
          </StyledAnchor>{" "}
          Find answers or chat to our support team.
        </P1>
      </Text>
      <Spacer height="2.5rem" />
    </Content>
    <FormContainer>
      <QuoteForm formType={FormType.callback} close={() => ({})} maxWidth="46rem" theme="grey" />
    </FormContainer>
  </StandardSection>
);

const Content = styled.div`
  position: relative;
`;

const StyledH1Large = styled(H1Large)`
  width: 100%;
  margin: 0 auto;
  padding: 3rem 0 0 0;
  text-align: center;

  @media only screen and (max-width: 60rem) {
    padding-bottom: 0.5rem;
  }
`;

const FormContainer = styled.div`
  position: relative;
  width: 100%;
  z-index: 1;

  @media only screen and (max-width: 50rem) {
    margin-bottom: 0;
  }
`;

const Text = styled.div`
  text-align: center;
  max-width: 46rem;
  margin: 0 auto;
`;

const StyledAnchor = styled.a`
  color: ${color.P100};
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;
